import { z } from 'zod';

import { MAX_WEIGHT_GRAMS, toGrams, WEIGHT_UNITS } from '@nucleus-commerce/core';

const DECIMAL = /^\d+(\.\d+)?$/;

/**
 * A weight as typed: the value text and its unit. An empty unit means none was chosen yet; the
 * input shows the organisation's default unit then and writes it down as soon as a value is typed.
 * Errors land on `weight` itself, where the backend's `body.weight` field errors land too.
 */
export const weightFieldSchema = z
  .object({ value: z.string().trim(), unit: z.enum(WEIGHT_UNITS).or(z.literal('')) })
  .refine((w) => w.value === '' || DECIMAL.test(w.value), { error: 'products:validation.weight' })
  .refine(
    (w) =>
      w.value === '' ||
      !DECIMAL.test(w.value) ||
      toGrams(Number(w.value), w.unit || 'g') <= MAX_WEIGHT_GRAMS,
    { error: 'products:validation.weightMax' },
  );

export type WeightFieldInput = z.input<typeof weightFieldSchema>;
export type WeightFieldOutput = z.output<typeof weightFieldSchema>;
